import AssessmentIcon from "@material-ui/icons/Assessment";
import { SCORECARDS_PATH } from "@internal/plugin-front-door-common";

/** Path, title and icon of each Front Door page, for its page and sidebar item. */
export const NAV = Object.freeze({
  scorecards: {
    path: SCORECARDS_PATH,
    title: "Scorecards",
    icon: AssessmentIcon,
  },
});
